import { TipoLocalNascimentoEnum } from 'graphql/types.generated'
import { MetaPath } from 'util/metaPath'
import { CidadaoAldeadoFormModel } from 'view/cidadao/create/types/model-cidadao'

import { RadioGroupField } from './RadioGroupField'

interface LocalNascimentoRadioGroupFieldProps {
  name: MetaPath<CidadaoAldeadoFormModel>['tipoLocalNascimento']
  required: boolean
}

export const localNascimentoOptions = [
  { value: TipoLocalNascimentoEnum.ALDEIA, label: 'Aldeia' },
  { value: TipoLocalNascimentoEnum.MUNICIPIO, label: 'Município' },
]

export function LocalNascimentoRadioGroupField(props: Readonly<LocalNascimentoRadioGroupFieldProps>) {
  const { name, required } = props

  return (
    <RadioGroupField label='Local de nascimento' name={name} options={localNascimentoOptions} required={required} />
  )
}
